import { Grid, TextField } from "@mui/material";
import { Accordion } from "../../../main/components/accordion/Accordion";
import { useState, useContext } from "react";
import { AlarmDetails } from "../types";
import { alarmsApi } from "../../../services/api";
import { FiEdit2 } from "react-icons/fi";
import { MainContext } from "../../../main/context/MainContextProvider";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import BaseButton from "../../../main/components/BaseButton";
import ConfirmationDialog from "./ConfirmationDialog";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
// import { ErrorModal } from "../../../main/components/ErrorModal";
import * as yup from "yup";

const possibleSolutionsSchema = yup.object().shape({
  possibleSolutions: yup.string().trim().nullable(),
});

export type EditPossibleSolutions = yup.InferType<
  typeof possibleSolutionsSchema
>;

export function CardAccordionsSolutions(props: {
  alarmDetails: AlarmDetails | null;
  onMount: () => void;
}) {
  const { alarmDetails, onMount } = props;
  const path = window.location.pathname;
  const alarmCode = path.split("/")[3];
  const [showPossibleSolutionsDetails, setShowPossibleSolutionsDetails] =
    useState<boolean>(false);
  const togglePossibleSolutionsDetails = () => {
    setShowPossibleSolutionsDetails(!showPossibleSolutionsDetails);
  };

  const [editSolutions, setEditSolutions] = useState(false);
  const [possibleSolutions, setPossibleSolutions] = useState(
    alarmDetails?.solutions || ""
  );
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;
  const [, setCurrentSolutions] = useState("");
  const [, setSaveConfirmationOpen] = useState<boolean>(false);
  const [isCancelConfirmationOpen, setCancelConfirmationOpen] =
    useState<boolean>(false);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
  const [showAddItemConfirmationModal, setShowAddItemConfirmationModal] =
    useState<boolean>(false);
  const [originalSolutions, setOriginalSolutions] = useState("");

  const handleEditSolutions = () => {
    //Armazena o valor original ao iniciar edição e não limpa o campo
    setOriginalSolutions(possibleSolutions);
    setEditSolutions(true);
  };

  const handleSaveSolutionsButton = () => {
    setShowAddItemConfirmationModal(true);
  };

  const handleSaveSolutions = async () => {
    try {
      const possibleSolutionsEdit = await alarmsApi.patchPossibleSolutions(
        alarmCode,
        possibleSolutions
      );
      console.log(
        `Salvando mensagem: "${possibleSolutions}"`,
        possibleSolutionsEdit
      );
      setCurrentSolutions(possibleSolutions);
      setEditSolutions(false);
    } catch (error) {}
  };

  const handleCancelSolutionsModal = () => {
    if (editSolutions) {
      // Reverte as alterações ao estado original
      setPossibleSolutions(originalSolutions);
      setEditSolutions(false);
      setCancelConfirmationOpen(false);
    } else {
      setSaveConfirmationOpen(false);
    }
  };

  const handleCancelSolutions = () => {
    setCancelConfirmationOpen(true);
  };

  return (
    <>
      {/* Possíveis Soluções */}
      <Accordion.Root>
        <Accordion.Header
          toggleDetails={togglePossibleSolutionsDetails}
          showDetails={showPossibleSolutionsDetails}
          title="Possíveis Soluções"
          typographySx={{ fontSize: { xs: "13px", sm: "16px" } }}
        />
        <Accordion.Content showDetails={showPossibleSolutionsDetails}>
          <Grid container alignItems="center">
            {!editSolutions && (
              <FiEdit2
                onClick={() => handleEditSolutions()}
                style={{
                  marginRight: "10px",
                }}
              />
            )}
            {editSolutions ? (
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    label="Possíveis Soluções"
                    value={possibleSolutions}
                    onChange={(e) => setPossibleSolutions(e.target.value)}
                    fullWidth
                  />
                </Grid>
                <Grid item container justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <DangerBaseButton
                      onClick={handleCancelSolutions}
                      title="Cancelar"
                      sx={{
                        height: "34px",
                        width: "95px",
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <BaseButton
                      onClick={handleSaveSolutionsButton}
                      sx={{
                        backGroundColor: primary,
                        borderColor: primary,
                        height: "34px",
                        width: "95px",
                        "& .MuiTypography-root": {
                          color: primary,
                        },
                        "&:hover": {
                          borderColor: primary,
                          backgroundColor: primary,
                          color: primary,
                          "& .MuiTypography-root": {
                            color: "#FFFFFF",
                          },
                        },
                      }}
                      title="Salvar"
                    />
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <>
                <Grid
                  item
                  style={{
                    fontWeight: "400",
                    fontSize: " 0.9rem",
                  }}
                >
                  {possibleSolutions ?? "Não informado"}
                  {/* {alarmDetails?.actions.possibleSolutions ?? "Não informado"} */}
                </Grid>
              </>
            )}
          </Grid>
        </Accordion.Content>
      </Accordion.Root>

      <ConfirmationDialog
        open={isCancelConfirmationOpen}
        title="Descartar alteração"
        message="Deseja descartar e cancelar as alterações?"
        onConfirm={handleCancelSolutionsModal}
        onCancel={() => setCancelConfirmationOpen(false)}
        onClose={() => setCancelConfirmationOpen(false)}
      />
      <ConfirmationModal
        open={showAddItemConfirmationModal}
        setOpen={setShowAddItemConfirmationModal}
        title="Editar possíveis soluções"
        contentText="Deseja confirmar a edição das possíveis soluções dos alarmes?"
        onConfirm={handleSaveSolutions}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <ActionAlert
        message="As possíveis soluções do alarme foram atualizados com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={() => setOpenSuccessModal(false)}
        onClose={() => onMount()}
      />
      <ActionAlert
        message="Ocorreu um erro ao editar as possíveis soluções do alarme! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
      />
    </>
  );
}
